import { Pipe, PipeTransform } from '@angular/core';
import {
  differenceInWeeks,
  differenceInMonths,
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
} from 'date-fns';
import { DateService } from '../services/date.service';

@Pipe({
  name: 'dateDiference',
})
export class DateDiferencePipe implements PipeTransform {
  transform(value: string | Date, fecha1: Date): string {
    const fecha2 = new Date(value);
    // const fecha1 = dateS.dateNow();

    // Diferencia en meses
    const months = differenceInMonths(fecha2, fecha1);

    if (months > 0) return `${months} mes${months > 1 ? 'es' : ''}`;

    // Diferencia en semanadas
    const weeks = differenceInWeeks(fecha2, fecha1);

    if (weeks > 0) return `${weeks} semana${weeks > 1 ? 's' : ''}`;

    // Diferencia en días
    const days = differenceInDays(fecha2, fecha1);

    if (days > 0) return `${days} día${days > 1 ? 's' : ''}`;

    // Diferencia en horas
    const hours = differenceInHours(fecha2, fecha1);

    if (hours > 0) return `${hours} hora${hours > 1 ? 's' : ''}`;

    // Diferencia en minutos
    const minutes = differenceInMinutes(fecha2, fecha1);

    if (minutes > 0) return `${minutes} minuto${minutes > 1 ? 's' : ''}`;

    return '';
  }
}
